
import { SWRConfiguration, SWRResponse } from "swr";

import { IReturn, QueryInstitutions, QueryInstitutionsResponse, Institution } from "@/api/dtos";
import { useMemo } from "react";
import useCachedDataQuery from '@/hooks/api/useCachedDataQuery';
import { AppSettings } from "@/AppSettings";

const getAdditionalState = (response?: SWRResponse<QueryInstitutionsResponse, QueryInstitutionsResponse>) => ({
    idMap: !!response?.data?.data?.length ? response?.data?.data?.reduce<Record<number, Institution>>((a, b) => {
        if (!b?.id) {
            return a;
        }
        
        a[b.id] = b;

        return a;
    },{}): undefined
});

const sortData = (a: Institution, b: Institution) => a.name! > b.name! ? 1 : -1;

export const useInstitutions = (query?: Partial<Institution>, configuration?: SWRConfiguration | undefined) => {
    return useCachedDataQuery(QueryInstitutions, { sortData, getAdditionalState, channel: AppSettings.channels.institution }, query, configuration);
}

export default useInstitutions;